/**
 * Internal dependencies.
 */
import edit from './edit';
import save from './save';
import metadata from './block.json';
import { AdminUsersIcon as icon } from '../../../components/Icons';

/**
 * WordPress dependencies.
 */
import { __ } from '@wordpress/i18n';
import { Icon } from '@wordpress/components';

/**
 * Block constants
 */
const { name, category, attributes } = metadata;

const settings = {
	title: __( 'Testimonial' ),
	description: __( 'Gutenify Testimonial' ),
	icon: <Icon icon={ icon } />,
	keywords: [
		'gutenify',
		__( 'Testimonial' ),
		__( 'Testimonial Item' ),
	],
	parent: [ 'gutenify/testimonials' ],
	example: {
		attributes: {
			image: {
				url: '',
				id: '',
			},
		},
	},
	attributes,
	edit,
	save,
	supports: {
		html: false,
	},
};

export { name, category, settings };
